










import {Component, Prop, Vue} from 'vue-property-decorator';

@Component
export default class HeaderBar extends Vue {
  @Prop({type: String, default: '/money'}) routerPath!: string;
  @Prop({type: String, required: true, default: ''}) headerTitle!: string;
  @Prop({type: Boolean, required: false, default: true}) hasIcon!: true;

  goBack(routerPath: string) {
    this.$router.push({
      path: routerPath,
    });
  }
}
